<template>
  <BaseView>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>Tutorial del Proyecto</v-card-title>
            <v-card-text>
              <h2>Bienvenido al Tutorial del Proyecto</h2>
              <p>En esta página, aprenderás a utilizar las diferentes funcionalidades de nuestro proyecto.</p>

              <h3>1. Navegación por Proyectos</h3>
              <p>En la barra lateral izquierda, encontrarás botones para navegar a la página de inicio, al CMS y al tutorial. Además, verás una lista de tus proyectos. Haz clic en el ícono de un proyecto para acceder a sus páginas y reuniones.</p>

              <h3>2. Uso del Chat Grupal</h3>
              <p>El chat grupal te permite comunicarte con otros miembros del proyecto en tiempo real. Para acceder al chat, haz clic en el botón de chat en la barra de navegación. Puedes enviar mensajes de texto y archivos adjuntos.</p>

              <h3>3. Métricas del Proyecto</h3>
              <p>En la página de métricas, puedes ver diferentes gráficos que muestran información sobre el proyecto. Por ejemplo, el gráfico de torta muestra el conteo de diferentes tipos de elementos en el proyecto.</p>

              <h3>4. Atajos de Teclado</h3>
              <p>Utiliza los siguientes atajos de teclado para navegar rápidamente por el proyecto:</p>
              <ul>
                <li><strong>Ctrl + E:</strong> Buscar elemento dialógico</li>
                <li><strong>Ctrl + P:</strong> Buscar proyecto</li>
                <li><strong>Ctrl + K:</strong> Buscar reunión</li>
              </ul>
              <p>Haz clic en el ícono de signo de interrogación en la esquina superior derecha para ver estos atajos en cualquier momento.</p>

              <h3>5. Ver y Editar Reuniones</h3>
              <p>Para ver y editar reuniones, utiliza el buscador de reuniones en la barra de navegación. Puedes buscar reuniones por nombre y fecha, y hacer clic en una reunión para ver más detalles o editarla.</p>

              <h3>6. Gestión de Tareas</h3>
              <p>Utiliza el tablero Kanban para gestionar las tareas del proyecto. Puedes crear, mover y eliminar tarjetas para organizar el trabajo de tu equipo.</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </BaseView>
</template>

<script>
import BaseView from "./BaseView.vue";

export default {
  name: "TutorialView",
  components: {
    BaseView,
  },
  created() {
    document.title = "Tutorial del Proyecto";
  },
}
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}

h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}

p, ul {
  margin-bottom: 10px;
}

ul {
  padding-left: 20px;
}
</style>